import React, { useState } from 'react';
import { useMediaQuery } from "react-responsive";
import './F24Datev.css';

import SlButton from '@shoelace-style/shoelace/dist/react/button';
import { MdAutoFixHigh, MdModeEdit  } from "react-icons/md";
import { IoAlertCircleOutline, IoDocuments, IoRocketSharp, IoLibrary  } from "react-icons/io5";

import FileDropZone from '../../components/FileDropZone/FileDropZone';
import AccordionList from '../../components/AccordionList/AccordionList';
import DialogError from '../../components/DialogError/DialogError';
import DialogFornitore from '../../components/DialogFornitore/DialogFornitore';
import DialogVersante from '../../components/DialogVersante/DialogVersante';
import DividerHeading from '../../components/DividerHeading/DividerHeading';

import { getLocale } from '../../locales/getLocale';
import { plainRetrieve } from '../../utils/safeStoring';
import { callExtractor, callCreateTele24 } from '../../utils/createTele24';
import { formatAddress, formatDate } from '../../components/AccordionList/AccordionList';
import { makeToast } from '../../utils/makeToast';
import { DEFAULT_FORNITORE } from '../../components/DialogFornitore/defaults';
import { applyBaseConfig } from './applyBaseConfig';


function F24Datev () {

    // insert base info for fornitore and versante
    applyBaseConfig();

    const isColumnLayout = useMediaQuery({ maxWidth: 1000 });
    
    const [isOpenFornitore, setIsOpenFornitore] = useState(false);
    const infoFornitore = plainRetrieve('infoFornitore') || DEFAULT_FORNITORE;
    const savedFornitore = plainRetrieve('savedFornitore') || '';

    const [isOpenVersante, setIsOpenVersante] = useState(false);
    const infoVersante = plainRetrieve('infoVersante') || [];

    const [isOpenError, setIsOpenError] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([
        // {"fileName": "This is a long title for a document.docx", 's3Key': '', 'uploaded': false, 'deleting': false}
    ]);
    const [isWaitingResponse, setIsWaitingResponse] = useState(false);
    const [telematicFiles, setTelematicFiles] = useState([]);


    const handleExtraction = (ocrMethod=false) => {
    
        // check if there are files to send
        if (uploadedFiles.length === 0) {
          return;
        }
    
        // check if all files are uploaded
        if (!uploadedFiles.every(file => file.uploaded)) {
          return;
        }
    
        setTelematicFiles([]);
        setIsWaitingResponse(true);
    
        // get s3 keys for all uploaded files
        const filesS3Keys = uploadedFiles.map(file => file.s3Key)
        // call extractor with BBOX or OCR method
        callExtractor(filesS3Keys, ocrMethod)
        .then((extractionResults) => {
          console.log(extractionResults);
    
          if (extractionResults.length > 0) {
            // loop over the extraction results and call the tele24 traduction, storing the result in a new list
            // Use Promise.all to wait for all async operations to complete
            Promise.all(extractionResults.map(el => callCreateTele24(el)))
            .then(newTelematicFiles => {
              console.log(newTelematicFiles);
    
              // check if all the telematic files were successfully created
              if (newTelematicFiles.every(item => Object.keys(item).length > 0)) {
                setTelematicFiles(newTelematicFiles);
                setIsWaitingResponse(false);
                // scroll to bottom of the page
                window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
            //   } else if (!ocrMethod) {
            //     // repeat the extraction process with OCR method
            //     makeToast("L'estrazione del documento è in corso. Per favore attendi fino alla conclusione del processo.")
            //     handleExtraction(true);
              } else {
                // extraction failed, show an error message
                // makeToast('C\'è stato un errore nel processo di estrazione, per favore controlla che il documento caricato sia conforme ai requisiti. Se necessario, contatta l\'amministratore di sistema.', 'warning');
                setIsOpenError(true);
                setIsWaitingResponse(false);
              }
            
            });
          }
    
        });
    
    };
    


    const ExtractButton = () => {
        return (
            <SlButton 
                variant="primary"
                size="large"
                pill
                className="btn-primary"
                style={{ alignSelf: 'center' }}
                loading={isWaitingResponse}
                onClick={() => {handleExtraction(false)}}
                disabled={
                    !(uploadedFiles.every(file => file.uploaded)) 
                    || (uploadedFiles.length === 0)
                    || (savedFornitore.length === 0) 
                    || (infoVersante.length === 0)
                }
            >
                <MdAutoFixHigh className='icon' />
                <span>{getLocale("F24Datev.btnExtract")}</span>
            </SlButton>
        );
    };



    return (

        <div className="page-F24Datev">
            
            <div className='top-row' style={{ flexDirection: `${isColumnLayout ? 'column' : 'row'}` }} >

                <div className='top-row-left' style={{ flex: 3 }}>

                    <span className='title'>
                        Elabora F24 in pochi secondi
                    </span>
                    <span>
                        Compila, elabora e invia i tuoi F24 in formato telematico. Basta caricare i dati, avviare il processo e ottenere il file pronto per la trasmissione in meno di un minuto!
                    </span>
                    <ul style={{ listStyleType: 'none', paddingLeft: '0' }}>
                        <li>
                            <div className='icon'><IoDocuments /></div>
                            <span><strong>Carica più F24</strong> - Supporta il caricamento massivo di file PDF, anche da contribuenti diversi.</span>
                        </li>
                        <li>
                            <div className='icon'><IoRocketSharp /></div>
                            <span><strong>Esecuzione rapida</strong> - Genera il file telematico in meno di un minuto.</span>
                        </li>
                        <li>
                            <div className='icon'><IoLibrary /></div>
                            <span><strong>Risultati organizzati</strong> - Gli F24 vengono automaticamente raggruppati per contribuente e data di pagamento.</span>
                        </li>
                    </ul>

                    {!isColumnLayout && (
                        <ExtractButton />
                    )}
                
                </div>

                <div className='top-row-right' style={{ flex: 7 }}>

                    <div className='row-buttons'>

                        {savedFornitore.length > 0 ? (
                            <div className='info-card' >
                                <span className='title'>Dati fornitore</span>
                                {savedFornitore === 'persona-fisica' ? (
                                    <div className='description'>
                                        <span>Codice Fiscale: <strong>{infoFornitore.codice_fiscale}</strong></span>
                                        <span>Dati anagrafici: <strong>{infoFornitore.persona_fisica.cognome} {infoFornitore.persona_fisica.nome}, {formatDate(infoFornitore.persona_fisica.data_di_nascita)}</strong></span>
                                        <span>Domicilio: <strong>{formatAddress(infoFornitore.persona_fisica.indirizzo_domicilio, infoFornitore.persona_fisica.comune_domicilio, infoFornitore.persona_fisica.provincia_domicilio,)}</strong></span>
                                    </div>
                                ) : (
                                    <div className='description'>
                                        <span>Partita IVA: <strong>{infoFornitore.codice_fiscale}</strong></span>
                                        <span>Denominazione: <strong>{infoFornitore.partita_iva.denominazione}</strong></span>
                                        <span>Sede: <strong>{formatAddress(infoFornitore.partita_iva.indirizzo_sede, infoFornitore.partita_iva.comune_sede, infoFornitore.partita_iva.provincia_sede,)}</strong></span>
                                    </div>
                                )}
                                {/* <button className='btn-edit' onClick={() => {setIsOpenFornitore(true)}} >
                                    <MdModeEdit />
                                    <span>Modifica</span>
                                </button> */}
                            </div>
                        ) : (
                            <div className='btn-alert' onClick={() => {setIsOpenFornitore(true)}} >
                                <IoAlertCircleOutline style={{ fontSize: '40px' }} />
                                <span>Aggiungi dati fornitore</span>
                            </div>
                        )}

                        {Object.keys(infoVersante).length > 0 ? (
                            <div className='info-card' >
                                <span className='title'>Dati versante</span>
                                <div className='row-content'>
                                    <span className='big-number'>{Object.keys(infoVersante).length}</span>
                                    <span>versanti<br/>inseriti</span>
                                </div>
                                {/* <button className='btn-edit' onClick={() => {setIsOpenVersante(true)}}>
                                    <MdModeEdit />
                                    <span>Modifica</span>
                                </button> */}
                            </div>
                        ) : (
                            <div className='btn-alert' onClick={() => {setIsOpenVersante(true)}} >
                                <IoAlertCircleOutline style={{ fontSize: '40px' }} />
                                <span>Aggiungi dati versante</span>
                            </div>
                        )}

                    </div>

                    <FileDropZone 
                        uploadedFiles={uploadedFiles}
                        setUploadedFiles={setUploadedFiles}
                        useCaseName="f24-extraction"
                        isWaiting={isWaitingResponse}
                    />
                
                </div>

                {isColumnLayout && (
                    <ExtractButton />
                )}

            </div>

            {telematicFiles.length > 0 && (
                <DividerHeading text="Risultati" />
            )}
            <AccordionList 
              data={telematicFiles}
            />

            <DialogError 
                isOpen={isOpenError}
                setIsOpen={setIsOpenError}
            />

            <DialogFornitore 
                isOpen={isOpenFornitore}
                setIsOpen={setIsOpenFornitore}
            />

            <DialogVersante
                isOpen={isOpenVersante}
                setIsOpen={setIsOpenVersante}
            />
        
        </div>

    );
}

export default F24Datev;
